import BaseApi from '@/api/BaseApi'

export default class TreeVehiclesApi extends BaseApi {
    async getTreeVehicles (params = {
        fleetId: null
    }) {
        return this.get('/api/v1.0/vehicles/tree', {
            'FleetId': params.fleetId
        })
    }
}
